import { Route, Routes, useNavigate } from "react-router-dom";
import { Security } from "@okta/okta-react";
import { toRelativeUrl } from "@okta/okta-auth-js";
import { oktaAuth } from "./config";
import Homepage from "./views/Homepage";
import UsersPage from "./views/UsersPage";
import ErrorComponent from "./views/ErrorComponent";
import { LoginCallback } from "@okta/okta-react";

const MyRoutes = () => {

	const history = useNavigate();
	const originalUri = async (_oktaAuth, originalUri) => {
		history(toRelativeUrl(originalUri || "/", window.location.origin));
	};

	return (
		<Security oktaAuth={oktaAuth} restoreOriginalUri={originalUri} >
			<Routes >
				<Route path="/login/callback" element={<LoginCallback errorComponent={ErrorComponent} />} />
				<Route path="/" exact={true} element={<Homepage />} />
				<Route path="/users" exact={true} element={<UsersPage />} />
			</Routes>
		</Security>
	);
};
export default MyRoutes;